var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("404 - page not found")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to home page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }